import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { Logo as CoursewareLogo } from '../../assets/Logo'
import { LanguageSwitcher } from '../../i18n/LanguageSwitcher'
import { FlexColumn, FlexRow } from '../FlexboxReusables/FlexItems'
import { Avatar, Tooltip, Typography } from 'antd'
import { ParticipantCourseContext } from '../CourseForParticipants/Context/ParticipantCourseContext'
import { QuestionCircleOutlined } from '@ant-design/icons'

const ParticipantNavbar = () => {
  const {
    allQuestionsAnswered,
    examAttemptCount,
    examTimeRemaining,
    hasAgreedToStartExam,
    logo,
    maxTries
  } = useContext(ParticipantCourseContext)

  const [ titleOfCurrentStep, setTitleOfCurrentStep ] = useState<string>('generic.courseContent')
  const hasCustomLogo = logo !== null && logo !== ''

  useEffect(() => {
    if (hasAgreedToStartExam) {
      setTitleOfCurrentStep('generic.exam')
    }

    if (allQuestionsAnswered) {
      setTitleOfCurrentStep('exam.examFinished')
    }
  }, [ hasAgreedToStartExam, allQuestionsAnswered ])

  const renderExamAttempts = () => {
    if (titleOfCurrentStep === 'generic.exam') {
      return (
        <>
          {` (${examAttemptCount }. Versuch)`}
          <Tooltip title={
            `Es stehen ${maxTries !== 0 
              ? `${maxTries}`
              : 'unbegrenzt'
            } Versuche zur Verfügung`
          }>
            <QuestionCircleOutlined style={{ marginLeft: '0.5em', cursor: 'help' }}/>
          </Tooltip>
        </>
      )
    }

    return ''
  }

  return (
    <NavbarContainer>
      <FlexRow>
        <FlexRow width='33%' justifyContent='flex-start' padding='0 0 0 1em'>
          <FlexColumn alignItems='flex-start'>
            <CurrentStepText>
              <FormattedMessage id={`${titleOfCurrentStep}`} />
              {renderExamAttempts()}
            </CurrentStepText>
            <Typography.Text>
              {hasAgreedToStartExam && !allQuestionsAnswered
                ? 
                <>
                  <FormattedMessage id='exam.timeRemaining' />
                  {' '} {examTimeRemaining}
                </>
                : ''
              }
            </Typography.Text>
          </FlexColumn>
        </FlexRow>
        <FlexRow width='33%'>
          <LogoContainer>
            {!hasCustomLogo
              ? (
                <>
                  <CoursewareLogo />
                  <CourseWareText>CourseWare</CourseWareText>
                </>
              )
              : <Avatar size={64} src={logo} shape='square' />
            }
          </LogoContainer>
        </FlexRow>
        <FlexRow width='33%' justifyContent='flex-end' padding='0 1em 0 0'>
          <LanguageSwitcher />
        </FlexRow>
      </FlexRow>
    </NavbarContainer>
  )
}

export default ParticipantNavbar

const NavbarContainer = styled.div`
  height: 70px;
  width: 100vw;
  background-color: #f0f2f5;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-bottom: 2px solid #ddd;
`

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 10em;
  margin: 0 auto;
`

const CourseWareText = styled.h1`
  font-size: 1.2em;
  margin-top: -0.5em;
  font-weight: bold;
  color: #14CCAA;
`

const CurrentStepText = styled(Typography.Text)`
  font-size: 1em;
  font-weight: bold;
`